export default __webpack_public_path__ + "static/MediaContentThree-48e6c73d81720e766a92132485057c8b.webp";